<template>
  <div class="sheet">
    <table border="1">
      <tr v-for="(item, index) in tableData" :key="index">
        <template v-if="index == num">
          <td class="title" colspan="2">
            <slot name="title"></slot>
          </td>
        </template>
        <template v-else>
          <td>{{ item.label }}</td>
          <td>{{ item.value }}</td>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "GmcsWebH5Index",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    title: {
      type: Boolean,
      default: () => false,
    },
    num: {
      type: Number,
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.title {
  box-sizing: border-box;
  padding-left: 24px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 26px;
}
.sheet {
  width: 100%;
  table {
    width: 100%;
    border-collapse: collapse;
    tr {
      border-color: #e2e4ea;
      width: 100%;
      height: 64px;
      line-height: 64px;
      td:nth-child(1) {
        box-sizing: border-box;
        padding-left: 24px;
        width: 35%;
        color: rgba(0, 0, 0, 0.6);
        font-size: 26px;
      }
      td:nth-child(2) {
        box-sizing: border-box;
        padding-left: 24px;
        color: rgba(0, 0, 0, 0.9);
        font-size: 26px;
      }
    }
  }
}
</style>
